export const SITE_TYPE = {
  ALL: 0,
  THROO: 1,
  BEHIND: 2,
  NONE: 99,
};
export const APP_TYPE = {
  KNOCK: 8,
};
